import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm sm:gap-4 sm:p-5" }
const _hoisted_2 = { class: "flex h-16 w-16 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-300 sm:h-20 sm:w-20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = { class: "text-sm text-slate-500" }
const _hoisted_6 = { class: "mt-3 inline-flex items-center overflow-hidden rounded-lg border border-slate-200" }
const _hoisted_7 = { class: "min-w-[42px] px-3 py-1 text-center font-semibold" }
const _hoisted_8 = { class: "flex h-20 shrink-0 flex-col items-end justify-between sm:h-24" }
const _hoisted_9 = { class: "text-slate-950" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.cartItem.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.env + 'storage/' + _ctx.cartItem.image,
            class: "h-full w-full rounded-xl object-cover"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createBlock(_component_Icon, {
            key: 1,
            icon: "solar:box-minimalistic-linear",
            class: "text-4xl"
          }))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_RouterLink, {
        to: `/products/${_ctx.cartItem.product_id}`,
        class: "font-semibold text-slate-950"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.cartItem.name_product), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("p", _hoisted_5, "Tamanho: " + _toDisplayString(_ctx.cartItem.size || '-'), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "px-3 py-1 text-slate-500",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('quantity', _ctx.cartItem, 'minus')))
        }, "-"),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.cartItem.quantity), 1),
        _createElementVNode("button", {
          type: "button",
          class: "px-3 py-1 text-slate-500",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('quantity', _ctx.cartItem, 'plus')))
        }, "+")
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        type: "button",
        class: "text-slate-300 hover:text-red-500",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove', _ctx.cartItem)))
      }, [
        _createVNode(_component_Icon, { icon: "mdi:trash-can-outline" })
      ]),
      _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.formatCurrency(_ctx.cartItem.price)), 1)
    ])
  ]))
}